<div class="coluna">
  <p>Aguarde enquanto estamos te redirecionando</p>
  <div class="k-i-loading ml-1 mr-1 centralizado" *ngIf="carregando" style="font-size: 40px;height: 90px;" ></div>
</div>
